// extracted by mini-css-extract-plugin
export default {"root":"styles_root__q3mjP","dragging":"styles_dragging__I3ICC"};